import React, { useState } from "react"
import PropTypes from "prop-types"
import { mediaQuery } from "@zendeskgarden/react-theming"
import styled from "styled-components"
import { Tabs, TabList, Tab } from "@zendeskgarden/react-tabs"
import { searchResult, collections } from "../../lib/prop-types"
import SearchResultsTabPanel from "./searchResultsTabPanel"

const StyledTabs = styled(Tabs)`
  overflow: initial;
`

const StyledTabList = styled(TabList)`
  margin: ${props => `0 -${props.theme.space.lg} ${props.theme.space.lg}`};
  padding: ${props => `0 ${props.theme.space.lg}`};
  color: ${props => props.theme.colors.header.textColor};
  border-bottom: ${props =>
    `${props.theme.borders.sm} ${props.theme.colors.document.horizontalRule}`};

  ${props => mediaQuery("down", "sm", props.theme)} {
    margin: ${props =>
      `0 -${props.theme.space.horz.md} ${props.theme.space.md}`};
    padding: ${props => `0 ${props.theme.space.horz.md}`};
  }
`

const StyledTab = styled(Tab)`
  color: ${props => props.theme.colors.search.searchHeader};

  &[aria-selected="true"],
  &:hover {
    color: ${props => props.theme.colors.header.desktopNavLinkActive};
  }

  ${props => mediaQuery("down", "sm", props.theme)} {
    width: 50%;
  }
`

const SearchResultsTabs = ({
  documentationResults,
  apiReferenceResults,
  searchTerm,
  documentationLoading,
  apiReferenceLoading,
  collection
}) => {
  const [selectedTab, setSelectedTab] = useState(`tab-${collection}`)

  return (
    <StyledTabs selectedItem={selectedTab} onChange={setSelectedTab}>
      <StyledTabList>
        <StyledTab
          item="tab-documentation"
          data-testid="dev-docs-documentation-tab"
        >
          Documentation
        </StyledTab>
        <StyledTab
          item="tab-api-reference"
          data-testid="dev-docs-api-reference-tab"
        >
          API Reference
        </StyledTab>
      </StyledTabList>

      <SearchResultsTabPanel
        item="tab-documentation"
        visible={selectedTab === "tab-documentation"}
        loading={documentationLoading}
        results={documentationResults}
        searchTerm={searchTerm}
      />

      <SearchResultsTabPanel
        item="tab-api-reference"
        visible={selectedTab === "tab-api-reference"}
        loading={apiReferenceLoading}
        results={apiReferenceResults}
        searchTerm={searchTerm}
      />
    </StyledTabs>
  )
}

SearchResultsTabs.propTypes = {
  documentationResults: PropTypes.arrayOf(PropTypes.shape(searchResult))
    .isRequired,
  apiReferenceResults: PropTypes.arrayOf(PropTypes.shape(searchResult))
    .isRequired,
  searchTerm: PropTypes.string,
  documentationLoading: PropTypes.bool,
  apiReferenceLoading: PropTypes.bool,
  collection: collections
}

SearchResultsTabs.defaultProps = {
  searchTerm: "",
  documentationLoading: false,
  apiReferenceLoading: false,
  collection: "documentation"
}

export default SearchResultsTabs
